import React, { useState } from "react";
import { HiOutlineMenu } from "react-icons/hi";
import { GiCrossMark } from "react-icons/gi";
import { NavLink } from "react-router-dom";
import "../stylesheets/header_footer.css";

const Header = () => {
  const [showheader, setshowheader] = useState(false);

  const path = window.location.pathname;

  const handler = () => {
    setshowheader(!showheader);
  };

  return (
    <div className="header">
      {showheader ? (
        <GiCrossMark
          onClick={handler}
          color="red"
          value={showheader}
          className="menu-button top-0 end-0 position-fixed"
        />
      ) : (
        <HiOutlineMenu
          onClick={handler}
          value={showheader}
          className="menu-button top-0 end-0 position-fixed"
        />
      )}
      <ul className={`${showheader ? "show-header" : "hide-header"} n-box1`}>
        <li>
          <NavLink className={`${path === "/" && "active"} link-menu`} to="/">
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            className={`${path === "/projects" && "active"} link-menu`}
            to="/projects"
          >
            Projects
          </NavLink>
        </li>
        <li>
          <NavLink
            className={`${path === "/contact" && "active"} link-menu`}
            to="/contact"
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Header;
